{
  "contact-update-dialog": {
    "buttons": {
      "confirm": "Confirm",
      "skip": "Skip"
    },
    "text": {
      "confirm-email": "Email confirmation",
      "confirm-email-hint": "Please confirm your email",
      "confirm-phone-number": "Phone number confirmation",
      "confirm-phone-number-hint": "Please confirm your phone number",
      "enter-email": "Email is missing",
      "enter-email-hint": "Please set your email",
      "enter-phone-number": "Phone number is missing",
      "enter-phone-number-hint": "Please set your phone number",
      "in-second": "in {{seconds}} s"
    }
  }
}
